export const HOME_LOCAL_STORAGE_KEYS = {
  state: '@curipod_v1_home_state',
  country: '@curipod_v1_home_country',
} as const;

export function getStoredHomeSelector(key: string): string | undefined {
  if (typeof window === 'undefined') {
    return undefined;
  }

  try {
    const data = localStorage.getItem(key);
    if (!data) {
      return undefined;
    }

    const parsed = JSON.parse(data) as { value?: unknown };
    return typeof parsed.value === 'string' ? parsed.value : undefined;
  } catch {
    return undefined;
  }
}

export function saveHomeSelector(key: string, value: string) {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    localStorage.setItem(key, JSON.stringify({ value }));
  } catch {}
}
